"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchSubscriptions = void 0;
var getOxygenId_1 = require("../common/getOxygenId");
var config_1 = require("../helpers/config");
var envConsts_1 = require("../helpers/envConsts");
var fetchWithToken_1 = require("../token/fetchWithToken");
var getCurrentToken_1 = require("../token/getCurrentToken");
var fetchSubscriptions = function () {
    return (0, getCurrentToken_1.getCurrentToken)().then(function (_a) {
        var accessToken = _a.accessToken;
        var oxygenId = (0, getOxygenId_1.getOxygenId)(accessToken);
        return (0, fetchWithToken_1.fetchWithToken)("".concat((0, config_1.getEnvValue)(envConsts_1.ENV_CONFIG_KEYS.ADMIN_API), "/internal/v1/users/").concat(oxygenId, "/subscriptions?filter[status]=active,expired"), {
            headers: { Region: (0, config_1.getRegion)() },
        });
    });
};
exports.fetchSubscriptions = fetchSubscriptions;
